import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {createRequestOption} from '../helpers/request-util';

@Injectable({
  providedIn: 'root'
})
export class RadioAccionService {

  public resourceUrl = environment.apiUrl + 'comparendo/radio_accion';

  constructor(public http: HttpClient) {
  }

  create(radioAccion: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, radioAccion);
  }

  update(radioAccion: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, radioAccion);
  }

  find(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`);
  }

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, {params: options});
  }

  listAll(): Observable<any> {
    return this.http.get<any[]>(`${this.resourceUrl}/list_all`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`);
  }

}
